import { useState } from "react";
import { Link } from "react-router-dom";
import { submitForm } from "@/lib/api";
export default function Footer() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  async function subscribe(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    setSubmitting(true);
    setError("");
    try {
      await submitForm("newsletter", form, { source: "footer" });
      setSubmitted(true);
    } catch (e) {
      setError(
        e instanceof Error
          ? e.message
          : "Unable to subscribe. Please try again.",
      );
    } finally {
      setSubmitting(false);
    }
  }
  return (
    <footer className="site-footer">
      <div className="shell">
        <div className="newsletter-row">
          <div>
            <p className="eyebrow light">Stay connected</p>
            <h2>Be part of what comes next.</h2>
            <p>
              Updates on education, enterprise, and collaboration across Africa
              and the diaspora.
            </p>
          </div>
          <div className="newsletter-form">
            <div role="status">
              {submitted && (
                <p>Thank you for subscribing. You’re on the list.</p>
              )}
            </div>
            {!submitted && (
              <form onSubmit={subscribe}>
                <label htmlFor="footer-email">Email address</label>
                <div className="newsletter-input-row">
                  <input
                    id="footer-email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    placeholder="you@example.com"
                    required
                  />
                  <button
                    className="button button-gold"
                    type="submit"
                    disabled={submitting}
                  >
                    {submitting ? "Subscribing…" : "Subscribe"}
                  </button>
                </div>
                {error && (
                  <p role="alert" className="form-error">
                    {error}
                  </p>
                )}
                <p className="fine-print">
                  Subscribe to receive Harambee updates. To request removal,
                  email{" "}
                  <a href="mailto:info@harambeeglobal.com">
                    info@harambeeglobal.com
                  </a>
                  .
                </p>
              </form>
            )}
          </div>
        </div>
        <div className="footer-grid">
          <div>
            <Link
              className="brand"
              to="/"
              aria-label="Harambee Global Ventures home"
            >
              <img src="/assets/brand/logo.png" alt="" width="64" height="52" />
              <span>
                HARAMBEE<small>GLOBAL VENTURES</small>
              </span>
            </Link>
            <p className="footer-about">
              Pulling together for African development, shared opportunity, and
              lasting wealth.
            </p>
            <p className="fine-print">
              An international subsidiary of
              <br />7 Hills Development Group LLC.
            </p>
          </div>
          <nav aria-label="About Harambee">
            <h3>Discover</h3>
            <Link to="/about">About us</Link>
            <Link to="/leadership">Our leadership</Link>
            <Link to="/insights">Insights & resources</Link>
            <Link to="/contact">Contact</Link>
          </nav>
          <nav aria-label="Areas of work">
            <h3>Our work</h3>
            <Link to="/trading-academy">Trading Academy</Link>
            <Link to="/advisory">Enterprise & advisory</Link>
            <Link to="/partnerships">Partnerships</Link>
            <Link to="/services#service-scope">Service availability</Link>
          </nav>
          <div>
            <h3>Let’s connect</h3>
            <p>
              Nairobi, Kenya
              <br />
              <span className="fine-print">
                Our intended East African anchor
              </span>
            </p>
            <a className="footer-email" href="mailto:info@harambeeglobal.com">
              info@harambeeglobal.com
            </a>
            <Link className="text-link light" to="/contact#contact-form">
              Start a conversation ↗
            </Link>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Harambee Global Ventures.</p>
          <Link to="/services#service-scope">Service scope & disclaimer</Link>
          <Link to="/contact#your-information">Your information</Link>
        </div>
      </div>
    </footer>
  );
}
